<template>
  <div class="login-container">
    <ImageBanner
            :authPage="true"
      ></ImageBanner>
    <div class="row justify-content-center" style="margin-top: 100px;">
      <div v-if="!isLoggedIn" class="col-md-6 col-sm-10">
        <form @submit.prevent="registering ? registerUser() : attemptLogin()" style="margin: 0 auto; text-align: left;">
          <div class="form-group">
            <label>Username</label>
            <input type="text" class="form-control" v-model="usernameInput" />
          </div>
          <div class="form-group">
            <label>Password</label>
            <input type="password" class="form-control" v-model="passwordInput" />
          </div>
          <div v-if="registering" class="form-group">
            <label>Email</label>
            <input type="email" class="form-control" v-model="emailInput" />
          </div>
          <div class="form-group">
            <label>Challenge phrase. What is the name of the mullet wearing character that Bill used to teach verbal nouns and adjectives? Dwayne ...</label>
            <input type="text" class="form-control" v-model="challengeInput" />
          </div>
          <div class="form-group">
            <button v-if="!registering" class="btn btn-primary" type="submit">Login</button>
            <button v-if="!registering" class="btn btn-link" @click.prevent="registering=true">Create New Account</button>
            <button v-if="registering" class="btn btn-primary" type="submit">Register</button>
            <button v-if="registering" class="btn btn-link" @click.prevent="registering=false">(login instead)</button>
          </div>
          <div v-if="authError" class="alert alert-danger" role="alert">
            {{authError}}
          </div>
        </form>
      </div>
    <div v-else class="col-md-6 col-sm-10">
        <div class="alert alert-success" role="alert">
        You are logged in as {{username}}.
        </div>

        <form @submit.prevent="registering ? registerUser() : attemptLogin()" style="margin: 0 auto; text-align: left;">
          <div class="form-group">
            <label>Username</label>
            <input type="text" class="form-control" v-model="username" disabled=""/>
          </div>
        <div class="form-group">
            <label>UserID</label>
            <input type="text" class="form-control" v-model="userId" disabled=""/>
          </div>
        <div class="form-group">
            <label>Email</label>
            <input type="text" class="form-control" v-model="userEmail" disabled=""/>
          </div>
          <div class="form-group">
            <button v-if="!registering" class="btn btn-primary" @click.prevent="logoutUser()">Logout</button>
          </div>
          <div v-if="authError" class="alert alert-danger" role="alert">
            {{authError}}
          </div>
        </form>
    </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapMutations } from 'vuex'
import { mapState } from 'vuex/dist/vuex.common.js';
import ImageBanner from '@/components/ImageBanner.vue';

const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
const USERNAME_REGEX = /^(?=.{2,20}$)(?![_.])(?!.*[_.]{2})[a-zA-Z0-9._]+(?<![_.])$/;
const PASSWORD_REGEX = /^.{2,}$/;

export default {
  name: 'LoginView',
  components: {
    ImageBanner
  },
  data() {
    return {
      registering: false,
      authError: '',
      usernameInput: '',
      passwordInput: '',
      emailInput: '',
      challengeInput: ''
    }
  },
  computed: {
    ...mapState('user', {
        username: state => state.username,
        userId: state => state.userId,
        isLoggedIn: state => state.token != null,
        userEmail: state => state.userEmail
    }),
  },
  methods: {
    ...mapMutations('user', ['loginUser','logoutUser']),
    async attemptLogin() {
      if (!this.challengeInput || this.challengeInput.toLowerCase() !== 'verbal') {
        this.authError = "Challenge failed";
        return;
      }
      try {
        const response = await axios.put(this.$server.apiUrl+'/auth/login', {
          username: this.usernameInput,
          password: this.passwordInput
        });
        console.log("Login response: ", response);
        this.loginUser({
          username: response.data.username,
          token: response.data.token,
          id: response.data.id,
          email: response.data.email,
          canEdit: response.data.canEdit
        });
        this.$cookie.set('user-info', JSON.stringify({
          username: response.data.username,
          token: response.data.token,
          userId: response.data.id,
        userEmail: response.data.email,
        }), 30);
        this.authError = null;
        this.$router.push({ name: 'Dictionary' });
      } catch (error) {
        this.authError = "Login failed";
      }
    },
    async registerUser() {
      if (!this.challengeInput || this.challengeInput.toLowerCase() !== 'verbal') {
        this.authError = "Challenge failed";
        return;
      }
      if (!USERNAME_REGEX.test(this.usernameInput)) {
        this.authError = "Username is invalid";
        return;
      }
      if (!PASSWORD_REGEX.test(this.passwordInput)) {
        this.authError = "Password is invalid";
        return;
      }
      if (!EMAIL_REGEX.test(this.emailInput)) {
        this.authError = "Email is invalid";
        return;
      }
      try {
        const response = await axios.post(this.$server.apiUrl+'/auth/register', {
          username: this.usernameInput,
          password: this.passwordInput,
          email: this.emailInput
        });
        this.loginUser({
          username: response.data.username,
          token: response.data.token,
          id: response.data.id,
          userEmail: response.data.email,
          canEdit: false
        });
        this.$cookie.set('user-info', JSON.stringify({
          username: response.data.username,
          token: response.data.token,
          userId: response.data.id,
            userEmail: response.data.email,
        }), 30);
        this.authError = null;
        this.$router.push({ name: 'Dictionary' });
      } catch (error) {
        this.authError = "Register failed: " + (error.response?.data || '');
      }
    }
  }
}
</script>
